import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { importCsvTypeInsert, importCustomerFromCsv } from '@/apis/customers'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { ImportCustomerFromCsvRequest } from '@/types/apis/customers/ImportCustomerFromCsvRequest'
import { ImportCustomerFromCsvResponse } from '@/types/apis/customers/ImportCustomerFromCsvResponse'

export const useImportCustomer = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<ImportCustomerFromCsvResponse>()

  const imp = useCallback(
    async (request: ImportCustomerFromCsvRequest) => {
      try {
        setLoading(true)
        const res = await importCustomerFromCsv(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.import.success') })
        navigate(routes.customers.path)
      } catch (error) {
        openNotification({ type: 'error', description: t('components.pages.admins.common.import.fail') })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  const importCustomerTypeInsert = useCallback(
    async (request: ImportCustomerFromCsvRequest) => {
      try {
        setLoading(true)
        const res = await importCsvTypeInsert(request)
        setResponse(res)
        openNotification({ description: t('pages.customers.importFromCsv.importSuccessfully') })
        navigate(routes.customers.path)
      } catch (error) {
        openNotification({ description: t('pages.customers.importFromCsv.importFailed'), type: 'error' })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    importCustomer: imp,
    importCustomerTypeInsert,
    response,
  }
}
